/* no-console */
import i18n from "@/assets/lang";

/* 姓名displayName */
import { strLengthCheck } from "@/utils/validate";

/* 用户名 */

/**
 * *2.用户名校验规则：
 * /^[a-zA-Z0-9_]{3,45}$/，保证全局唯一*
 */
export function checkUserName(rule, value, callback) {
  const reg = /^[a-zA-Z0-9_]{3,45}$/;
  if (value === "") {
    callback(new Error(i18n.t("public.enterUsername")));
  } else if (reg.test(value)) {
    callback();
  } else {
    callback(new Error(i18n.t("public.enterCorrectUserName")));
  }
}

export function checkName(rule, value, callback) {
  if (value === "") {
    callback(new Error(i18n.t("userCenter.enterName")));
  } else if (strLengthCheck(value, 4, 30)) {
    callback();
  } else {
    callback(new Error(i18n.t("public.enterCorrectName")));
  }
}

/**
 * 密码规则
 */
export function validatePassword(rule, value, callback) {
  const reg =
    /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(i18n.t("public.characterLimit")));
  }
}

/**
 * 验证字符长度length不超过64位,无字符规则
 */
export function lengthCheck(rule, str, callback) {
  const len = str.length;
  if (len > 64) {
    callback(new Error(i18n.t("public.characterLength")));
  } else {
    callback();
  }
}

/* 企业地址 */
export function validateAddress(rule, value, callback) {
  if (!value || (value.length >= 4 && value.length <= 100)) {
    callback();
  } else {
    callback(new Error(i18n.t("public.addressCharacters")));
  }
}

/**
 * 验证编码
 */
export function validateCode(rule, value, callback) {
  const reg = rule.reg || /^[-_a-zA-Z0-9]+$/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(rule.reg ? rule.message : i18n.t("public.enterEnglishNumbers")));
  }
}

/**
 * 验证认证标识
 */
export function validateAuthenticationMark(rule, value, callback) {
  if (value.includes("$")) {
    callback(new Error(rule.reg ? rule.message : i18n.t("public.cannotUseCharacters")));
  } else {
    callback();
  }
}

/**
 * 验证认证秘钥
 */
export function validateAuthenticationKey(rule, value, callback) {
  if (value.length < 8 || value.length > 512) {
    callback(new Error(rule.reg ? rule.message : i18n.t("createAsset.validateAuthenticationKey")));
  } else {
    callback();
  }
}

/**
 * @Description:判断两个时间区间是否重叠
 * @author shuo.li
 * @date 2021.11.3
 * @LastEditors:
 * @LastEditTime:
 * @param {Array} timeA [startTimeString,endTimeString]
 * @param {Array} timeB [startTimeString,endTimeString]
 * @returns {Boolean}
 *
 */
export function checkDateOverlap(timeA, timeB) {
  if (Array.isArray(timeA) || !Array.isArray(timeB)) { return false; }
  const maxA = new Date(timeA[0]).getTime();
  const maxB = new Date(timeB[0]).getTime();
  const minA = new Date(timeA[1]).getTime();
  const minB = new Date(timeB[1]).getTime();
  const max = [maxA, maxB];
  const min = [minA, minB];
  return Math.max.apply(null, max) <= Math.min.apply(null, min);
}

export function checkTimeOverlap(time1, time2) {
  // 最后用于比较的时间数据
  const times1 = [];
  const times2 = [];
  // time1和time2是源数据
  if (time1.nextStartDay) {
    const time1StartList = time1.startTime.split(":");
    if (time1StartList[0] === "00") {
      time1.startTime = `24:${time1StartList[1]}`;
    }
  }
  if (time1.nextEndDay) {
    const time1EndList = time1.endTime.split(":");
    if (time1EndList[0] === "00") {
      time1.endTime = `24:${time1EndList[1]}`;
    }
  }
  if (time2.nextStartDay) {
    const time2StartList = time2.startTime.split(":");
    if (time2StartList[0] === "00") {
      time2.startTime = `24:${time2StartList[1]}`;
    }
  }
  if (time2.nextEndDay) {
    const time2EndList = time2.endTime.split(":");
    if (time2EndList[0] === "00") {
      time2.endTime = `24:${time2EndList[1]}`;
    }
  }

  /*
   * 判断是否跨天，整理比较的数据
   * 20210607,修改了次日的逻辑，开始时间为次日，结束时间必定为次日
   */
  if (time1.nextStartDay) {
    // 不做任何修改，直接push
    times1.push([time1.startTime, time1.endTime]);
  } else {
    // 结束时间有跨天
    if (time1.nextEndDay) {
      if (time1.endTime !== "24:00") {
        times1.push([time1.startTime, "24:00"], ["00:00", time1.endTime]);
      } else {
        times1.push([time1.startTime, "24:00"]);
      }
    } else {
      times1.push([time1.startTime, time1.endTime]);
    }
  }
  if (time2.nextStartDay) {
    // 不做任何修改，直接push
    times2.push([time2.startTime, time2.endTime]);
  } else {
    // 结束时间有跨天
    if (time2.nextEndDay) {
      if (time2.endTime !== "24:00") {
        times2.push([time2.startTime, "24:00"], ["00:00", time2.endTime]);
      } else {
        times2.push([time2.startTime, "24:00"]);
      }
    } else {
      times2.push([time2.startTime, time2.endTime]);
    }
  }
  // console.log(times1)
  // console.log(times2)
  // if (time1.startTime < time1.endTime) {
  //   if (time1.nextEndDay) {
  //     if (time1.endTime !== '24:00') {
  //       times1.push([time1.startTime, "24:00"], ["00:00", time1.endTime])
  //     } else {
  //       times1.push([time1.startTime, "24:00"])
  //     }
  //   } else {
  //     times1.push([time1.startTime, time1.endTime])
  //   }
  // }
  // // 不存在时间相同的情况，填写时已经做了判断，即使是单班制的8:00-次日8:00，也不会进入此逻辑
  // if (time1.startTime > time1.endTime) {
  //   if (time1.endTime === '00:00') {
  //     times1.push([time1.startTime, "24:00"])
  //   } else if (time1.startTime === '24:00') {
  //     times1.push(["00:00", time1.endTime])
  //   } else {
  //     times1.push([time1.startTime, "24:00"], ["00:00", time1.endTime])
  //   }
  // }
  // if (time2.startTime < time2.endTime) {
  //   if (time2.nextEndDay) {
  //     if (time2.endTime !== '24:00') {
  //       times2.push([time2.startTime, "24:00"], ["00:00", time2.endTime])
  //     } else {
  //       times2.push([time2.startTime, "24:00"])
  //     }
  //   } else {
  //     times2.push([time2.startTime, time2.endTime])
  //   }
  // }
  // if (time2.startTime > time2.endTime) {
  //   if (time2.endTime === '00:00') {
  //     times2.push([time2.startTime, "24:00"])
  //   } else if (time2.startTime === '24:00') {
  //     times2.push(["00:00", time2.endTime])
  //   } else {
  //     times2.push([time2.startTime, "24:00"], ["00:00", time2.endTime])
  //   }
  // }
  const flagList = [];
  // 循环比较时间段是否冲突
  for (let i = 0; i < times1.length; i++) {
    for (let j = 0; j < times2.length; j++) {
      // 每层都需要比较
      flagList.push(check(times1[i][0], times1[i][1], times2[j][0], times2[j][1]));
    }
  }
  // 全为true，才是通过
  return flagList.some(item => !item);
}

// 在上述函数执行后，把跨天情况整合，在此处比较就不需要考虑跨天了
function check(a, b, x, y) {
  if (b === x && a > x) {
    return false;
  }
  // 起始时间一样，必然会有重合
  if (a === x) {
    return false;
  }
  if (a < x && b > x) {
    return false;
  }
  return !(a > x && y > a);
}
